import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

interface ThematicResponse {
  data: {
    thematics: any[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class ThematicService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getThematics(gsid: number): Observable<ThematicResponse> {
    const headers = new HttpHeaders({
      'cli': 'Web',
      'appversion': '1.5',
      'serviceversion': '2',
      'latitude': '0',
      'longitude': '0',
      'placeType': 'company',
      'placeId': gsid,
      'infoLevel': '2',
      'priority': '1',
      'Authorization': `Bearer ${localStorage.getItem('gstoken') || ''}`
    });

    return this.http.get<ThematicResponse>(`${this.baseUrl}/thematics/list`, { headers });
  }

}